[
  {
    "code": "SM-01",
    "name": "Acquaviva"
  },
  {
    "code": "SM-06",
    "name": "Borgo Maggiore"
  },
  {
    "code": "SM-02",
    "name": "Chiesanuova"
  },
  {
    "code": "SM-03",
    "name": "Domagnano"
  },
  {
    "code": "SM-04",
    "name": "Faetano"
  },
  {
    "code": "SM-05",
    "name": "Fiorentino"
  },
  {
    "code": "SM-08",
    "name": "Montegiardino"
  },
  {
    "code": "SM-07",
    "name": "San Marino"
  },
  {
    "code": "SM-09",
    "name": "Serravalle"
  }
]